import request from '@/util/request';
import qs from 'qs';

export const getDownloadBill = (params, options) =>
  request.get('/api/v4ward/pay/payTradeall/downloadBill', Object.assign({}, options, { params }));

export const getList = (params, options) =>
  request.get('/api/v4ward/pay/payTradeall/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/v4ward/pay/payTradeall/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/v4ward/pay/payTradeall/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/v4ward/pay/payTradeall/submit', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/pay/payTradeall/submit', params, options);
